export function hasSearchParam(key) {
  const url = new URL(window.location.href);
  return url.searchParams.has(key);
}

export function setSearchParam(key, value) {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState(null, '', url.toString());
}

export function deleteSearchParam(key) {
  const url = new URL(window.location.href);
  if (url.searchParams.has(key)) {
    url.searchParams.delete(key);
    window.history.pushState(null, '', url.toString());
  }
}

export function getSearchParam(key, { toInt = false } = {}) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);
  if (toInt) {
    if (value == null || value.trim() === '') {
      return null;
    }
    const num = Number(value);
    if (isNaN(num)) {
      return null;
    }
    return num;
  }
  return value;
}
